module.exports = __webpack_public_path__ + "img/phone.71674532.png";